import { css } from "lit";

export const styles = css`
  .form-content {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 16px;
    max-height: 80vh;
    overflow-y: auto;
  }

  .form-row {
    display: flex;
    gap: 16px;
    align-items: flex-start;
  }

  .form-row > * {
    flex: 1;
  }

  .date-time-section {
    display: flex;
    flex-direction: column;
  }

  .section-header {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .section-label {
    font-weight: var(--sds-typography-weight-medium);
    color: var(--sds-color-text-default-default);
  }

  .section-subtitle {
    color: var(--sds-color-text-default-tertiary);

    font-family: var(--sds-typography-family-body);
    font-size: var(--sds-typography-body-size-medium);
    font-style: normal;
    font-weight: var(--sds-typography-weight-regular);
    line-height: 140%;
  }

  .toggle-field {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
`;
